import React, { useContext, useEffect, useState } from "react";
import {
  View,
  TouchableOpacity,
  FlatList,
  RefreshControl} from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import commonStyles from "../../styles/commonStyles";
import AntDesign from "@expo/vector-icons/AntDesign";
import CommonDropdown from "../../components/Dropdown";
import { getUserIdToUse } from "../../utils/getUserIdToUse";
import { ApiService } from "../../service/ApiService";
import { ITaxDoc } from "../../types/ITaxDoc";
import SkeletonLoader from "../../components/SkeletonLoader";
import { useIsFocused } from "@react-navigation/native";
import { RefreshContext } from "../../contexts/refreshContext";
import OverflowTooltipText from "../../components/OverflowTooltipText";
import AppText from "../../components/AppText";

type AgreementsProps = {
  navigation: {
    navigate: (screen: string, params?: object) => void;
    goBack: () => void;
  };
};

export const years = [
  { value: "All", title: "All" },
  { value: 2020, title: "2020" },
  { value: 2021, title: "2021" },
  { value: 2022, title: "2022" },
  { value: 2023, title: "2023" },
  { value: 2024, title: "2024" },
  { value: 2025, title: "2025" },
  { value: 2026, title: "2026" },
];
const TaxPage: React.FC<AgreementsProps> = ({ navigation }) => {
  const [year, setYear] = useState(2025);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [taxDocs, setTaxDoc] = useState<ITaxDoc[]>([]);
  const { refreshTrigger } = useContext(RefreshContext);
  const isFocused = useIsFocused();

  const onYearDropdownChange = async (value: any) => {
    setTaxDoc([]);
    setYear(value);
    console.log("the daa......... ", value);
    setLoading(true);
    if (value === "All") {
      fetchTaxDoxData();
    } else {
      try {
        userIdToUse = await getUserIdToUse();
        const response = await ApiService.get<ITaxDoc[]>(
          `portal/shareholderTaxDoc/byPartnerId/${userIdToUse}?taxYear=${value}`
        );

        const data = response.data;

        console.log("data... ", response);
        setTaxDoc(data);
        setLoading(false);
      } catch (error) {
        setError("Error fetching data");
        setLoading(false);
      }
    }
  };
  let userIdToUse: string | null;

  const fetchTaxDoxData = async () => {
    setLoading(true);
    try {
      userIdToUse = await getUserIdToUse();
      const response = await ApiService.get<ITaxDoc[]>(
        `portal/shareholderTaxDoc/byPartnerId/${userIdToUse}`
      );
      const data = response.data;
      console.log("data... ", response);
      setTaxDoc(data);
      setLoading(false);
    } catch (error) {
      setError("Error fetching data");
      setLoading(false);
    }
  };
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = () => {
    onYearDropdownChange(2025);
  };
  useEffect(() => {
    if (isFocused && refreshTrigger > 0) {
      onYearDropdownChange(2025);
    }
  }, [refreshTrigger]);

  const renderAgreement = ({ item }: { item: ITaxDoc }) => (
    <View
      style={[
        commonStyles.subContainer,
        commonStyles.p14,
        commonStyles.mt20,
        commonStyles.mlar2,
      ]}
      testID="agreement-item"
    >
      <TouchableOpacity
        testID={`entity-${item.id}`}
        onPress={() => navigation.navigate("TaxDetails", { tax: item })}
      >
        <View style={commonStyles.cardItemblock}>
          <OverflowTooltipText
            testID={`entity-name-${item.id}`}
            text={item.entityName}
            style={commonStyles.detailsSubHeader}
            onPress={() => navigation.navigate("TaxDetails", { tax: item })}
          />
          <AntDesign
            name="arrow-right"
            size={22}
            color="#666"
            marginBottom={4}
            testID={`entity-arrow-${item.id}`}
          />
        </View>
      </TouchableOpacity>
    </View>
  );

  return (
    <SafeAreaView
      edges={["bottom", "left", "right"]}
      style={[commonStyles.container, commonStyles.screenBottomGap]}
    >
      <View style={commonStyles.headerContainer}>
        <AppText testID="your-k1s" style={commonStyles.header}>
          Your K1s
        </AppText>
      </View>
      <View style={{ width: "31%", marginBottom: -20 }}>
        <CommonDropdown
          testID="year-Dropdown"
          data={years}
          value={year}
          onChange={(item) => onYearDropdownChange(item.value)}
          placeholder="Year"
        />
      </View>
      <View
        style={[
          commonStyles.subContainer,
          commonStyles.p14,
          commonStyles.mt20,
          commonStyles.mlar2,
        ]}
      >
        <TouchableOpacity
          onPress={() =>
            navigation.navigate("K1TotalSummary", { tax: taxDocs, year: year })
          }
        >
          <View style={commonStyles.cardItemblock}>
            <AppText
              testID="k1-total-summary"
              style={commonStyles.detailsSubHeader}
            >
              K1 Totals Summary
            </AppText>
            <AntDesign
              testID="k1-arrow"
              name="arrow-right"
              size={22}
              color="#666"
              marginBottom={4}
            />
          </View>
        </TouchableOpacity>
      </View>

      <AppText
        testID="details"
        style={[
          commonStyles.detailsHeader,
          commonStyles.mt15,
          commonStyles.ml12,
        ]}
      >
        Details
      </AppText>
      {loading ? (
        <View testID="skeleton-loader">
          <SkeletonLoader rows={10} rowHeight={40}></SkeletonLoader>
        </View>
      ) : !taxDocs ? (
        <View style={{ alignItems: "center", marginTop: 20 }}>
          <AppText testID="no-date-found">No data found</AppText>
        </View>
      ) : (
        <FlatList
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={handleRefresh} />
          }
          testID="entity-name"
          data={taxDocs}
          keyExtractor={(item) => item.id.toString()}
          renderItem={renderAgreement}
          contentContainerStyle={commonStyles.pb16}
        />
      )}
    </SafeAreaView>
  );
};

export default TaxPage;
